export enum UserActions{
  LOAD_USER = "LOAD_USER",
  SET_USER = "SET_USER",
  ERROR_REQUEST = "ERROR_REQUEST",
  LOGOUT = "LOGOUT",
  USER_DISCONECTED = "USER_DISCONECTED",
  SET_THEME = "SET_THEME",
  SET_LANGUAGE = "SET_LANGUAGE"
}

export interface IUserState{
  id: number;
  firstname: string;
  lastname: string;
  image_profile?: string;
  email: string;
  profile: {
    id: number;
    name: string;
    type: {
      id: number;
      name: string;
    }
  };
  company?:{
    id:number;
    name:string;
    alias:string;
  };
  permissions:string[];

  theme?: string;
  language?: string;

  /* Controle de resposta */
  userLoad:boolean;
  errorRequest:boolean;
  userDisconected:boolean;
  isLogout:boolean;

  current_date:string;
}